import React from "react";
//#region types
import { InvoiceOtherGroupProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { SelectInputProps, ToggleProps } from "models/propTypes/wintFormPropsTypes";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { HorizontalFormField, Toggle, SelectInput, GroupSection } from "components/common/wintForms";
import InvoiceLayoutSelector from "./invoiceLayoutSelector";
//#endregion
import { LanguageHelper, LocalizationHelperInstance } from "utils/helpers";

function DisplayGroup({ connect, isQuotation }: InvoiceOtherGroupProps) {
  const layoutSelectorConnection = connect("otherSettings.invoiceLayout");
  const layoutSelectorOnChange = (type: React.ChangeEvent<any> | WintSuperkollAPIModel.InvoicePdfTemplate) => {
    layoutSelectorConnection.setValue(type as unknown as WintSuperkollAPIModel.InvoicePdfTemplate);
  };
  const layoutSelectorOnBlur = (e: React.FocusEvent<any>) => {};
  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.DisplaySettings)}
      icon={IconDefinitionConstants.WEye}
    >
      <HorizontalFormField<any>
        Component={InvoiceLayoutSelector}
        {...layoutSelectorConnection}
        onChange={layoutSelectorOnChange}
        onBlur={layoutSelectorOnBlur}
        label={LocalizationHelperInstance.getFormattedMessage(
          isQuotation ? TranslationKeys.Quotation.InvoiceDesign : TranslationKeys.Invoice.InvoiceDesign
        )}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          isQuotation
            ? TranslationKeys.Quotation.InvoiceDesignDescription
            : TranslationKeys.Invoice.InvoiceDesignDescription
        )}
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("otherSettings.languageKey")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Language)}
        items={LanguageHelper.getLanguageCodeList().map((key) => ({
          value: key as string,
          label: LocalizationHelperInstance.getFormattedMessage(`Language.${(key as string).toUpperCase()}`),
        }))}
      />
      <HorizontalFormField<ToggleProps>
        Component={Toggle}
        {...connect("otherSettings.showCurrencyCode")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ShowCurrencyCode)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Invoice.ShowCurrencyCodeHelpText
        )}
      />
      {!isQuotation ? (
        <>
          <HorizontalFormField<ToggleProps>
            Component={Toggle}
            {...connect("otherSettings.showReferenceInAddress")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ShowReference)}
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Invoice.ShowReferenceHelpText
            )}
          />
          <HorizontalFormField<ToggleProps>
            Component={Toggle}
            {...connect("otherSettings.showCustomerDeliveryAddress")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ShowCustomer)}
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Invoice.ShowCustomerHelpText
            )}
          />
        </>
      ) : (
        <></>
      )}
    </GroupSection>
  );
}

export default DisplayGroup;
